var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 16.125L5.53695 14.5242C5.80316 14.4218 5.93626 14.3707 6.06079 14.3038C6.1714 14.2444 6.27685 14.1759 6.37603 14.0989C6.48769 14.0123 6.58853 13.9115 6.79021 13.7098L15.25 5.24998C16.0784 4.42156 16.0784 3.07841 15.25 2.24998C14.4216 1.42156 13.0784 1.42156 12.25 2.24998L3.79021 10.7098C3.58853 10.9115 3.48769 11.0123 3.40104 11.124C3.32408 11.2231 3.25555 11.3286 3.19618 11.4392C3.12933 11.5637 3.07814 11.6968 2.97575 11.963L1.375 16.125ZM1.375 16.125L2.91859 12.1117C3.02905 11.8245 3.08428 11.6809 3.17901 11.6151C3.26179 11.5577 3.36423 11.5359 3.46322 11.5548C3.5765 11.5765 3.68529 11.6853 3.90286 11.9028L5.59718 13.5971C5.81475 13.8147 5.92354 13.9235 5.94517 14.0368C5.96408 14.1358 5.94234 14.2382 5.88486 14.321C5.81909 14.4157 5.67549 14.471 5.3883 14.5814L1.375 16.125Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditModal);
export default __webpack_public_path__ + "static/media/editModal.4c346dcf6ecaa24b502e5a23575ff6b9.svg";
export { ForwardRef as ReactComponent };